module.exports = __webpack_public_path__ + "img/CM-JN-24-Chevy-Modern.3c4a338c.jpg";